/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function syncProductCardVariant(card) {
    if (!card) {
      return;
    }

    var selectedSwatch = card.querySelector('.color-swatch__radio:checked');
    if (!selectedSwatch) {
      return;
    }

    var variantId = selectedSwatch.getAttribute('data-variant-id');
    var variantUrl = selectedSwatch.getAttribute('data-variant-url');
    var imageWrapper = card.querySelector('.product-item__image-wrapper');
    var titleLink = card.querySelector('.product-item__title');
    var formVariantInput = card.querySelector('form[action*="/cart/add"] [name="id"]');

    if (formVariantInput && variantId) {
      formVariantInput.value = variantId;
    }

    if (variantUrl) {
      if (imageWrapper) {
        imageWrapper.setAttribute('href', variantUrl);
      }

      if (titleLink) {
        titleLink.setAttribute('href', variantUrl);
      }
    }
  }

  function syncAllProductCardVariants(root) {
    (root || document).querySelectorAll('.product-item').forEach(syncProductCardVariant);
  }

  function showInlineToast(message, type) {
    var id = 'shipping-extra-toast-container';
    var container = document.getElementById(id);

    if (!container) {
      container = document.createElement('div');
      container.id = id;
      container.style.position = 'fixed';
      container.style.right = '16px';
      container.style.bottom = '16px';
      container.style.zIndex = '99999';
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.gap = '8px';
      container.style.maxWidth = '360px';
      document.body.appendChild(container);
    }

    var toast = document.createElement('div');
    toast.textContent = message;
    toast.style.padding = '10px 12px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '13px';
    toast.style.lineHeight = '1.35';
    toast.style.boxShadow = '0 4px 14px rgba(0,0,0,0.18)';
    toast.style.color = '#ffffff';
    toast.style.background = type === 'error' ? '#c0392b' : '#2d6cdf';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(6px)';
    toast.style.transition = 'all 160ms ease';
    container.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(6px)';
      setTimeout(function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 170);
    }, 3400);
  }

  function toProperties(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      if (key.indexOf('properties[') !== 0 || key[key.length - 1] !== ']') {
        return;
      }

      var propKey = key.slice(11, -1);
      if (typeof value === 'string' && value.trim() !== '') {
        properties[propKey] = value.trim();
      }
    });

    return properties;
  }

  function postCartItems(payload) {
    var localeRoot = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';
    return fetch(localeRoot + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });
  }

  function parseCartAddError(response) {
    if (!response || response.ok) {
      return Promise.resolve('');
    }

    return response.json()
      .then(function (payload) {
        if (!payload) {
          return '';
        }

        return payload.description || payload.message || payload.status || '';
      })
      .catch(function () {
        return '';
      });
  }

  function updateCartLine(lineKey, quantity, properties) {
    var localeRoot = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';
    return fetch(localeRoot + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        properties: properties
      })
    });
  }

  function normalizeLineProperties(rawProperties) {
    if (!rawProperties) {
      return {};
    }

    if (Array.isArray(rawProperties)) {
      var mapped = {};
      rawProperties.forEach(function (entry) {
        if (!entry) {
          return;
        }

        if (Array.isArray(entry) && entry.length >= 2) {
          mapped[String(entry[0])] = entry[1];
          return;
        }

        if (typeof entry === 'object' && entry.first !== undefined) {
          mapped[String(entry.first)] = entry.last;
        }
      });
      return mapped;
    }

    if (typeof rawProperties === 'object') {
      return Object.assign({}, rawProperties);
    }

    return {};
  }

  function resolveVariantIdFromHandle(handle) {
    if (!handle) {
      return Promise.resolve(NaN);
    }

    var localeRoot = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';
    return fetch(localeRoot + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch product by handle');
        }
        return response.json();
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          return NaN;
        }
        return parseInt(product.variants[0].id, 10);
      })
      .catch(function () {
        return NaN;
      });
  }

  function syncShippingExtrasInCart() {
    var localeRoot = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';

    return fetch(localeRoot + '/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }
        return response.json();
      })
      .then(function (cart) {
        var parentQtyByVariant = {};
        var extraLinesByParentVariant = {};
        var updates = {};
        var parentFlagClearOps = [];

        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var parentVariantId = props._shipping_extra_for_variant_id;

          if (!parentVariantId) {
            parentQtyByVariant[String(item.variant_id)] = item.quantity;
            return;
          }

          var parentIdStr = String(parentVariantId);
          if (!extraLinesByParentVariant[parentIdStr]) {
            extraLinesByParentVariant[parentIdStr] = [];
          }
          extraLinesByParentVariant[parentIdStr].push(item);
        });

        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var parentVariantId = props._shipping_extra_for_variant_id;

          if (!parentVariantId) {
            return;
          }

          var desiredQty = parentQtyByVariant[String(parentVariantId)] || 0;
          if (desiredQty !== item.quantity) {
            updates[item.key] = desiredQty;
          }
        });

        cart.items.forEach(function (item) {
          var props = normalizeLineProperties(item.properties);
          if (props._shipping_extra_for_variant_id) {
            return;
          }

          var selectedLabel = props['Shipping Extra'];
          var hasExtraFlag = (typeof selectedLabel === 'string' && selectedLabel.trim() !== '') || !!props._shipping_extra_fee;
          if (!hasExtraFlag) {
            return;
          }

          var children = extraLinesByParentVariant[String(item.variant_id)] || [];
          var hasMatchingChild = false;

          if (children.length > 0) {
            var normalizedSelectedLabel = (typeof selectedLabel === 'string') ? selectedLabel.trim() : '';
            hasMatchingChild = children.some(function (child) {
              var childProps = normalizeLineProperties(child.properties);
              var childLabel = (typeof childProps._shipping_extra_label === 'string') ? childProps._shipping_extra_label.trim() : '';

              if (!normalizedSelectedLabel) {
                return true;
              }

              return !childLabel || childLabel === normalizedSelectedLabel;
            });
          }

          if (hasMatchingChild) {
            return;
          }

          delete props['Shipping Extra'];
          delete props._shipping_extra_fee;
          parentFlagClearOps.push({
            key: item.key,
            variantId: item.id,
            quantity: item.quantity,
            properties: props
          });
        });

        var hasQtyUpdates = Object.keys(updates).length > 0;
        var hasFlagClears = parentFlagClearOps.length > 0;
        if (!hasQtyUpdates && !hasFlagClears) {
          return false;
        }

        var didUpdate = false;
        var syncPromise = Promise.resolve();

        if (hasQtyUpdates) {
          syncPromise = fetch(localeRoot + '/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to sync shipping extras');
            }
            didUpdate = true;
          });
        }

        return syncPromise.then(function () {
          if (!hasFlagClears) {
            return didUpdate;
          }

          var chain = Promise.resolve();
          parentFlagClearOps.forEach(function (op) {
            chain = chain.then(function () {
              return postCartItems({
                items: [
                  {
                    id: op.variantId,
                    quantity: op.quantity,
                    properties: op.properties
                  }
                ]
              })
                .then(function (addResponse) {
                  if (!addResponse.ok) {
                    return parseCartAddError(addResponse).then(function (message) {
                      throw new Error(message || 'Failed to recreate cart line without shipping flag');
                    });
                  }

                  return updateCartLine(op.key, 0, {});
                })
                .then(function (removeResponse) {
                  if (!removeResponse.ok) {
                    throw new Error('Failed to remove old cart line with shipping flag');
                  }
                  didUpdate = true;
                });
            });
          });

          return chain.then(function () {
            return didUpdate;
          });
        });
      });
  }

  function getCurrentVariantId(form) {
    var idInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : NaN;
  }

  function getQuantity(form) {
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getCartRowQuantity(button) {
    var lineItem = button.closest('.line-item');
    if (!lineItem) {
      return 1;
    }

    var qtyInput = lineItem.querySelector('.quantity-selector__value');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function isDynamicCheckoutSubmit(event, form) {
    if (!form) {
      return false;
    }

    if (form.getAttribute('data-shipping-extra-checkout-intent') === 'true') {
      return true;
    }

    var submitter = event && event.submitter;
    if (!submitter || typeof submitter.closest !== 'function') {
      return false;
    }

    return !!submitter.closest('.shopify-payment-button');
  }

  function getSelectedShippingExtraOption(form) {
    if (!form) {
      return null;
    }

    var extras = form.querySelector('.js-shipping-extras');
    if (!extras) {
      return null;
    }

    return extras.querySelector('.js-shipping-extra-option.is-selected');
  }

  function getClosestProductFormFromEvent(event) {
    var target = event && event.target;
    if (target && typeof target.closest === 'function') {
      var directForm = target.closest('form.product-form');
      if (directForm) {
        return directForm;
      }
    }

    var path = (event && typeof event.composedPath === 'function') ? event.composedPath() : [];
    for (var i = 0; i < path.length; i += 1) {
      var node = path[i];
      if (node && node.tagName && String(node.tagName).toLowerCase() === 'form' && node.matches && node.matches('form.product-form')) {
        return node;
      }
    }

    return null;
  }

  function isAcceleratedCheckoutClick(event) {
    var target = event && event.target;
    if (target && typeof target.closest === 'function' && target.closest('.shopify-payment-button')) {
      return true;
    }

    var path = (event && typeof event.composedPath === 'function') ? event.composedPath() : [];
    for (var i = 0; i < path.length; i += 1) {
      var node = path[i];
      if (!node) {
        continue;
      }

      var className = typeof node.className === 'string' ? node.className : '';
      var tagName = node.tagName ? String(node.tagName).toLowerCase() : '';

      if (className.indexOf('shopify-payment-button') !== -1) {
        return true;
      }

      if (tagName === 'shopify-accelerated-checkout' || tagName === 'shopify-buy-it-now-button') {
        return true;
      }
    }

    return false;
  }

  function addProductWithShippingExtra(form, selectedOption, shouldGoToCheckout) {
    var addButton = form.querySelector('[data-action="add-to-cart"]');
    var extraVariantId = parseInt(selectedOption.getAttribute('data-shipping-extra-variant-id'), 10);
    var extraHandle = selectedOption.getAttribute('data-shipping-extra-handle') || '';
    var mainVariantId = getCurrentVariantId(form);
    var quantity = getQuantity(form);

    if (!Number.isFinite(mainVariantId)) {
      return Promise.resolve({ skipped: true });
    }

    if (addButton) {
      addButton.setAttribute('disabled', 'disabled');
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    return Promise.resolve(
      (Number.isFinite(extraVariantId) && extraVariantId > 0)
        ? extraVariantId
        : resolveVariantIdFromHandle(extraHandle)
    )
      .then(function (resolvedExtraVariantId) {
        if (!Number.isFinite(resolvedExtraVariantId) || resolvedExtraVariantId <= 0) {
          throw new Error('Shipping extra is not configured');
        }

        var formData = new FormData(form);
        var properties = toProperties(formData);
        properties['Shipping Extra'] = selectedOption.getAttribute('data-shipping-extra-label') || '';
        properties['_shipping_extra_fee'] = '$' + (selectedOption.getAttribute('data-shipping-extra-price') || '');

        var payload = {
          items: [
            {
              id: mainVariantId,
              quantity: quantity,
              properties: properties
            },
            {
              id: resolvedExtraVariantId,
              quantity: quantity,
              properties: {
                '_shipping_extra_for_variant_id': String(mainVariantId),
                '_shipping_extra_label': selectedOption.getAttribute('data-shipping-extra-label') || ''
              }
            }
          ]
        };

        return postCartItems(payload).then(function (response) {
          return { response: response, quantity: quantity };
        });
      })
      .then(function (result) {
        if (!result.response || !result.response.ok) {
          return parseCartAddError(result.response).then(function (message) {
            throw new Error(message || 'Failed to add shipping extra');
          });
        }

        if (shouldGoToCheckout) {
          var localeRoot = (window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '';
          window.location.href = localeRoot + '/checkout';
          return;
        }

        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = ((window.theme && window.theme.localeRootUrl) ? window.theme.localeRootUrl : '') + '/cart';
          return;
        }

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: result.quantity, variant: null }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .finally(function () {
        form.removeAttribute('data-shipping-extra-checkout-intent');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (addButton) {
          addButton.removeAttribute('disabled');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-shipping-extra-option');
    if (!button) {
      return;
    }

    var container = button.closest('.js-shipping-extras');
    if (!container) {
      return;
    }

    var options = container.querySelectorAll('.js-shipping-extra-option');
    var nameInput = container.querySelector('.js-shipping-extra-name');
    var feeInput = container.querySelector('.js-shipping-extra-fee');
    var includesLabel = container.querySelector('.js-shipping-now-includes');
    var isActive = button.classList.contains('is-selected');

    options.forEach(function (opt) {
      opt.classList.remove('is-selected');
      opt.setAttribute('aria-pressed', 'false');
    });

    if (isActive) {
      if (nameInput) {
        nameInput.value = '';
      }
      if (feeInput) {
        feeInput.value = '';
      }
      if (includesLabel) {
        includesLabel.textContent = 'Inside Delivery';
      }
      return;
    }

    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');

    if (nameInput) {
      nameInput.value = button.getAttribute('data-shipping-extra-label') || '';
    }

    if (feeInput) {
      var price = button.getAttribute('data-shipping-extra-price') || '';
      feeInput.value = price ? '$' + price : '';
    }

    if (includesLabel) {
      includesLabel.textContent = button.getAttribute('data-shipping-includes-msg') || 'Inside Delivery';
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form.product-form')) {
      return;
    }

    var selectedOption = getSelectedShippingExtraOption(form);
    if (!selectedOption) {
      return;
    }
    var shouldGoToCheckout = isDynamicCheckoutSubmit(event, form);

    event.preventDefault();
    event.stopImmediatePropagation();
    addProductWithShippingExtra(form, selectedOption, shouldGoToCheckout)
      .catch(function (error) {
        var message = (error && error.message) ? error.message : '';
        var fallbackMessage = 'Shipping extra product is missing or unavailable. Please create/publish the service product in Shopify admin.';
        showInlineToast(message ? (fallbackMessage + ' (' + message + ')') : fallbackMessage, 'error');
      });
  }, true);

  document.addEventListener('change', function (event) {
    var swatch = event.target;
    if (!swatch || !swatch.matches('.color-swatch__radio')) {
      return;
    }

    syncProductCardVariant(swatch.closest('.product-item'));
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target) {
      return;
    }

    var form = getClosestProductFormFromEvent(event);
    if (!form) {
      return;
    }

    if (isAcceleratedCheckoutClick(event)) {
      var selectedOption = getSelectedShippingExtraOption(form);
      if (selectedOption) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.setAttribute('data-shipping-extra-checkout-intent', 'true');
        addProductWithShippingExtra(form, selectedOption, true).catch(function (error) {
          var message = (error && error.message) ? error.message : '';
          var fallbackMessage = 'Shipping extra product is missing or unavailable. Please create/publish the service product in Shopify admin.';
          showInlineToast(message ? (fallbackMessage + ' (' + message + ')') : fallbackMessage, 'error');
        });
        return;
      }

      form.setAttribute('data-shipping-extra-checkout-intent', 'true');
      return;
    }

    if (target.closest('[data-action="add-to-cart"]')) {
      var addToCartSelectedOption = getSelectedShippingExtraOption(form);
      if (addToCartSelectedOption) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addProductWithShippingExtra(form, addToCartSelectedOption, false).catch(function (error) {
          var message = (error && error.message) ? error.message : '';
          var fallbackMessage = 'Shipping extra product is missing or unavailable. Please create/publish the service product in Shopify admin.';
          showInlineToast(message ? (fallbackMessage + ' (' + message + ')') : fallbackMessage, 'error');
        });
        return;
      }

      form.removeAttribute('data-shipping-extra-checkout-intent');
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-cart-shipping-extra-option');
    if (!button) {
      return;
    }

    event.preventDefault();

    var wrap = button.closest('.js-cart-shipping-extra');
    if (!wrap) {
      return;
    }

    var parentVariantId = parseInt(wrap.getAttribute('data-parent-variant-id'), 10);
    var extraHandle = button.getAttribute('data-shipping-extra-handle') || '';
    var extraLabel = button.getAttribute('data-shipping-extra-label') || '';
    var quantity = getCartRowQuantity(button);

    if (!Number.isFinite(parentVariantId) || parentVariantId <= 0) {
      return;
    }

    var buttons = wrap.querySelectorAll('.js-cart-shipping-extra-option');
    buttons.forEach(function (btn) { btn.setAttribute('disabled', 'disabled'); });

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    resolveVariantIdFromHandle(extraHandle)
      .then(function (resolvedExtraVariantId) {
        if (!Number.isFinite(resolvedExtraVariantId) || resolvedExtraVariantId <= 0) {
          throw new Error('Missing shipping extra variant');
        }

        var payload = {
          items: [
            {
              id: resolvedExtraVariantId,
              quantity: quantity,
              properties: {
                '_shipping_extra_for_variant_id': String(parentVariantId),
                '_shipping_extra_label': extraLabel
              }
            }
          ]
        };

        return postCartItems(payload);
      })
      .then(function (response) {
        if (!response.ok) {
          return parseCartAddError(response).then(function (message) {
            throw new Error(message || 'Failed to add cart shipping extra');
          });
        }
        showInlineToast('Shipping extra added to cart.', 'success');
        window.location.reload();
      })
      .catch(function (error) {
        var message = (error && error.message) ? error.message : '';
        var fallbackMessage = 'Could not add shipping extra. Check that the service product handle is correct and product is active.';
        showInlineToast(message ? (fallbackMessage + ' (' + message + ')') : fallbackMessage, 'error');
      })
      .finally(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        buttons.forEach(function (btn) { btn.removeAttribute('disabled'); });
      });
  });

  function runCartSync() {
    if (window.__shippingExtrasSyncRunning) {
      return;
    }

    window.__shippingExtrasSyncRunning = true;
    syncShippingExtrasInCart()
      .then(function (didUpdate) {
        if (!didUpdate) {
          return;
        }

        if (window.location.pathname.indexOf('/cart') !== -1) {
          window.location.reload();
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(function () {
      })
      .finally(function () {
        window.__shippingExtrasSyncRunning = false;
      });
  }

  document.addEventListener('click', function (event) {
    var removeTrigger = event.target.closest('[data-action="decrease-quantity"][data-quantity="0"]');
    if (!removeTrigger) {
      return;
    }

    if (window.location.pathname.indexOf('/cart') === -1) {
      return;
    }

    setTimeout(runCartSync, 250);
    setTimeout(runCartSync, 900);
  }, true);

  if (window.location.pathname.indexOf('/cart') !== -1) {
    runCartSync();
  }

  document.addEventListener('cart:refresh', runCartSync);
  document.addEventListener('shopify:section:load', function (event) {
    syncAllProductCardVariants(event.target);
  });
  syncAllProductCardVariants(document);
})();
